import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/bankCard/xy.png'
import _imports_1 from '@/assets/bankCard/qs.png'
import _imports_2 from '@/assets/bankCard/pf.png'
import _imports_3 from '@/assets/bankCard/ny.png'
import _imports_4 from '@/assets/bankCard/jt.png'
import _imports_5 from '@/assets/bankCard/js.png'
import _imports_6 from '@/assets/bankCard/ws.png'
import _imports_7 from '@/assets/bankCard/hx.png'
import _imports_8 from '@/assets/bankCard/ncxys.png'
import _imports_9 from '@/assets/bankCard/gd.png'
import _imports_10 from '@/assets/bankCard/gs.png'
import _imports_11 from '@/assets/bankCard/dy.png'
import _imports_12 from '@/assets/bankCard/hq.png'
import _imports_13 from '@/assets/bankCard/zgpa.png'
import _imports_14 from '@/assets/bankCard/ms.png'
import _imports_15 from '@/assets/bankCard/qt.png'


const _hoisted_1 = { style: {"background-color":"#f5f5f5","margin-top":"0.7rem"} }
const _hoisted_2 = { class: "bank_card_box" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = { class: "right" }
const _hoisted_5 = { class: "bank_card_item_box" }
const _hoisted_6 = { class: "bank_card_item" }
const _hoisted_7 = { class: "bank_card_item_img" }
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 4,
  src: _imports_0
}
const _hoisted_13 = {
  key: 5,
  src: _imports_1
}
const _hoisted_14 = {
  key: 6,
  src: _imports_2
}
const _hoisted_15 = {
  key: 7,
  src: _imports_3
}
const _hoisted_16 = {
  key: 8,
  src: _imports_4
}
const _hoisted_17 = {
  key: 9,
  src: _imports_5
}
const _hoisted_18 = {
  key: 10,
  src: _imports_6
}
const _hoisted_19 = {
  key: 11,
  src: _imports_7
}
const _hoisted_20 = {
  key: 12,
  src: _imports_8
}
const _hoisted_21 = {
  key: 13,
  src: _imports_9
}
const _hoisted_22 = {
  key: 14,
  src: _imports_10
}
const _hoisted_23 = {
  key: 15,
  src: _imports_11
}
const _hoisted_24 = {
  key: 16,
  src: _imports_12
}
const _hoisted_25 = {
  key: 17,
  src: _imports_13
}
const _hoisted_26 = {
  key: 18,
  src: _imports_14
}
const _hoisted_27 = {
  key: 19,
  src: _imports_15
}
const _hoisted_28 = { class: "bank_card_item_right" }
const _hoisted_29 = { style: {"margin":"0.02rem 0 0.12rem","color":"#333333","font-size":"0.16rem","display":"flex","justify-content":"space-between"} }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { style: {"margin":"0.02rem 0 0.12rem","color":"#333333","font-size":"0.12rem"} }
const _hoisted_32 = { style: {"color":"#333333","font-size":"0.18rem","font-weight":"bold"} }

import leftTemplate from "@/components/leftTemplate.vue";
import bacnkCardAdd from "@/components/card/bacnk_card_add.vue";
import gotoAuthentication from "@/components/card/gotoAuthentication.vue";
import { ref, nextTick } from "vue";
import { Axios } from "@/assets/js/ls_com_axios.js";
import { useRouter } from "vue-router";
import { ElMessage, ElMessageBox } from "element-plus";

export default /*@__PURE__*/_defineComponent({
  __name: 'bank_card',
  setup(__props) {

document.title = "标识山西-我的银行卡";
let allCheckbox = ref(false);
const router = useRouter();

//添加银行
let addCardVisible = ref(false);
const bacnkCardAddRef = ref();
const handleCard = async () => {
  Axios("get", `/member/login-info`, {}, false, async (res) => {
    let data = res.data.data;
    if (data.realStatus == 0) {
      ElMessageBox.confirm(
        '您还未进行实名认证，请先实名认证',
        '',
        {
          confirmButtonText: '前往认证',
          cancelButtonText: '取消',
          type: 'error',
          customClass: 'bank_card',
          center: true,
        }
      )
        .then(() => {
          router.push({
            path: "/AuthenTication",
            query: { num: 3 }
          });
        }).catch(() => {

        })
      return
    } else if (data.realStatus == 1) {
      ElMessage.error("认证状态：审核中");
      return
    } else if (data.realStatus == 2) {
      addCardVisible.value = true;
      await nextTick();
      bacnkCardAddRef.value.init();

      if (!router.currentRoute.value.query.showDialog) {
        router.push({
          query: {},
          replace: true,
        });
      }
    } else {
      ElMessage.error("认证状态：认证失败");
      return
    }
  });

};
const handleCloseCard = () => {
  if (router.currentRoute.value.query.showDialog) {
    router.replace({
      path: "/requirementManagement", // replace with your actual route
      query: {
        state: "first",
      },
    });
  }
  addCardVisible.value = false;
};
//认证
let addAuthenVisible = ref(false);
const handleAuthen = () => {
  addAuthenVisible.value = true;
};
//我的银行卡
const list = ref([]);
const init = () => {
  Axios("get", "/member/member-bank/my-list", false, false, (res) => {
    console.log(res);
    list.value = res.data.data;
    if (router.currentRoute.value.query.showDialog) {
      handleCard();
    }
  });
};
init();
const onSubmit = () => {
  addCardVisible.value = false;
  console.log(
    "router.currentRoute.value.query.showDialog",
    router.currentRoute.value.query.showDialog
  );

  if (router.currentRoute.value.query.showDialog) {
    handleCloseCard();
  }
  init();
};
//解除绑订

const bankCardDel = (id) => {
  Axios("delete", `/member/member-bank/${id}`, false, false, (res) => {
    ElMessage({
      message: "解除成功",
      type: "warning",
    });
    init();
  });
};

return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(leftTemplate, { left_tabShow: 'bank_card' })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", { class: "add_bank_card_box" }, [
          _createElementVNode("div", {
            class: "add_bank_card",
            onClick: handleCard
          }, "添加银行卡")
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                (item.bankName == '中信银行')
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: require('@/assets/bankCard/zx.png')
                    }, null, 8, _hoisted_8))
                  : (item.bankName == '中国银行')
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        src: require('@/assets/bankCard/zg.png')
                      }, null, 8, _hoisted_9))
                    : (item.bankName == '招商银行')
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 2,
                          src: require('@/assets/bankCard/zs.png')
                        }, null, 8, _hoisted_10))
                      : (item.bankName == '储蓄银行')
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 3,
                            src: require('@/assets/bankCard/cx.png')
                          }, null, 8, _hoisted_11))
                        : (item.bankName == '兴业银行')
                          ? (_openBlock(), _createElementBlock("img", _hoisted_12))
                          : (item.bankName == '齐商银行')
                            ? (_openBlock(), _createElementBlock("img", _hoisted_13))
                            : (item.bankName == '浦发银行')
                              ? (_openBlock(), _createElementBlock("img", _hoisted_14))
                              : (item.bankName == '农业银行')
                                ? (_openBlock(), _createElementBlock("img", _hoisted_15))
                                : (item.bankName == '交通银行')
                                  ? (_openBlock(), _createElementBlock("img", _hoisted_16))
                                  : (item.bankName == '建设银行')
                                    ? (_openBlock(), _createElementBlock("img", _hoisted_17))
                                    : (item.bankName == '微商银行')
                                      ? (_openBlock(), _createElementBlock("img", _hoisted_18))
                                      : (item.bankName == '华夏银行')
                                        ? (_openBlock(), _createElementBlock("img", _hoisted_19))
                                        : (item.bankName == '农村信用社银行')
                                          ? (_openBlock(), _createElementBlock("img", _hoisted_20))
                                          : (item.bankName == '光大银行')
                                            ? (_openBlock(), _createElementBlock("img", _hoisted_21))
                                            : (item.bankName == '工商银行')
                                              ? (_openBlock(), _createElementBlock("img", _hoisted_22))
                                              : (item.bankName == '东亚银行')
                                                ? (_openBlock(), _createElementBlock("img", _hoisted_23))
                                                : (item.bankName == '华侨银行')
                                                  ? (_openBlock(), _createElementBlock("img", _hoisted_24))
                                                  : (item.bankName == '中国平安银行')
                                                    ? (_openBlock(), _createElementBlock("img", _hoisted_25))
                                                    : (item.bankName == '民生银行')
                                                      ? (_openBlock(), _createElementBlock("img", _hoisted_26))
                                                      : (item.bankName == '其他')
                                                        ? (_openBlock(), _createElementBlock("img", _hoisted_27))
                                                        : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("span", null, _toDisplayString(item.bankName), 1),
                  _createElementVNode("span", {
                    style: {"color":"#C01A26","font-size":"0.14rem","cursor":"pointer"},
                    onClick: ($event: any) => (bankCardDel(item.id))
                  }, "解除绑定", 8, _hoisted_30)
                ]),
                _createElementVNode("div", _hoisted_31, _toDisplayString(item.bankType == "DEBITCARD"
                  ? "储蓄卡"
                  : item.bankType == "CREDITCARD"
                    ? "信用卡"
                    : item.bankType == "ALIPAY"
                      ? "支付宝"
                      : item.bankType == "WECHAT"
                        ? "微信"
                        : ""), 1),
                _createElementVNode("div", _hoisted_32, _toDisplayString(item.bankNo), 1)
              ])
            ]))
          }), 256))
        ])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      title: "",
      modelValue: _unref(addAuthenVisible),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(addAuthenVisible) ? (addAuthenVisible).value = $event : addAuthenVisible = $event)),
      "align-center": "",
      width: "480px",
      "close-on-click-modal": false
    }, {
      default: _withCtx(() => [
        _createVNode(gotoAuthentication)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "添加银行卡",
      modelValue: _unref(addCardVisible),
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(addCardVisible) ? (addCardVisible).value = $event : addCardVisible = $event)),
      "align-center": "",
      width: "480px",
      "before-close": handleCloseCard,
      "close-on-click-modal": false
    }, {
      default: _withCtx(() => [
        _createVNode(bacnkCardAdd, {
          ref_key: "bacnkCardAddRef",
          ref: bacnkCardAddRef,
          onSubmit: onSubmit
        }, null, 512)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})